import React, { useEffect, useState } from "react";

// Router v5
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

// Components
import Navbar from "components/Navbar/Navbar";
import Hero from "components/Hero/Hero";
import About from "components/About/About";
import HowItWorks from "components/HowItWorks/HowItWorks";
import StatsSection from "components/StatsSection/StatsSection";
import Services from "components/Services/Services";
import CaseStudies from "components/CaseStudies/CaseStudies";
import Pricing from "components/Pricing/Pricing";
import Contact from "components/Contact/Contact";
import Footer from "components/Footer/Footer";
import LoadingScreen from "components/LoadingScreen/LoadingScreen";
import ScrollToTop from "components/ScrollToTop";  // ✅ Import karo

// Blogs
import Blogs from "components/Blogs/Blogs";
import BlogDetail from "components/Blogs/BlogDetail";

// Animation
import Aos from "aos";
import "aos/dist/aos.css";

// Home Page
const Home = () => {
  return (
    <>
      <Hero />
      <About />
      <HowItWorks />
      <StatsSection />
      <Services />
      <CaseStudies />
      <Pricing />
      <Contact />
    </>
  );
};

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    Aos.init({
      duration: 2000,
      offset: 10,
      once: false,
      mirror: true,
    });
  }, []);

  const handleLoadingComplete = () => {
    setIsLoading(false);
  };

  return (
    <Router>
      <ScrollToTop />  {/* ✅ Yahan add karo */}
      {isLoading && <LoadingScreen onComplete={handleLoadingComplete} />}

      <div className={`app-container ${isLoading ? "loading" : ""}`}>
        <Navbar />

        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/blogs" component={Blogs} />
          <Route path="/blogs/:slug" component={BlogDetail} />
        </Switch>

        <Footer />
      </div>
    </Router>
  );
}

export default App;